import axios from "axios";
import PATH from "./URL";

async function GetFilters(func, category){
    const response =  await axios.get(`${PATH}/api/v1/get_filters/${category}`)
    return func(response.data)
}

export default GetFilters